"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalHeader_component_exports = {};
__export(GlobalHeader_component_exports, {
  GlobalHeader: () => GlobalHeader,
  default: () => GlobalHeader_component_default
});
module.exports = __toCommonJS(GlobalHeader_component_exports);
var import_react = __toESM(require("react"));
var import_Helpers = require("../../../utils/Helpers");
var import_AvatarPopup = require("../../molecules/AvatarPopup/AvatarPopup.component");
var import__ = require("./..");
var import_molecules = require("../../molecules");
var import_roles = require("../../../utils/roles");
var import_baseTheme = __toESM(require("../../../themes/baseTheme"));
var import_useBreakpoints = require("../../../utils/useBreakpoints/useBreakpoints.hook");
var import_GlobalHeader = __toESM(require("../contexts/GlobalHeader/GlobalHeader.state"));
var import_GlobalHeader2 = require("./GlobalHeader.styled");
var _excluded = ["BreadcrumbComponent", "hamburgerMenuTopOffset", "hideAppSelector", "hideHamburgerMenu", "showHamburgerMenuOnLoad", "isHabitatContext", "currentApp", "currentPlatform", "darkMode", "currentRole", "availableRoles", "popoversStackOrders", "stackOrder", "appElement", "withKebabMenu", "tabIndexSkipToContent", "stickyControl", "withTitleWrap", "avatarButtonVariant", "showAvatarLogoutButton", "studentVariant", "CustomLogoutActionElement", "previousArrowLabel", "nextArrowLabel", "titleTextAlignment"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var GlobalHeader = /* @__PURE__ */ (0, import_react.forwardRef)(function(_ref, heightRef) {
  var _headerHeightRef$curr, _props$closeAvatarBut, _props$closeAvatarBut2;
  var BreadcrumbComponent = _ref.BreadcrumbComponent, _ref$hamburgerMenuTop = _ref.hamburgerMenuTopOffset, hamburgerMenuTopOffset = _ref$hamburgerMenuTop === void 0 ? 0 : _ref$hamburgerMenuTop, _ref$hideAppSelector = _ref.hideAppSelector, hideAppSelector = _ref$hideAppSelector === void 0 ? true : _ref$hideAppSelector, _ref$hideHamburgerMen = _ref.hideHamburgerMenu, hideHamburgerMenu = _ref$hideHamburgerMen === void 0 ? false : _ref$hideHamburgerMen, _ref$showHamburgerMen = _ref.showHamburgerMenuOnLoad, showHamburgerMenuOnLoad = _ref$showHamburgerMen === void 0 ? false : _ref$showHamburgerMen, _ref$isHabitatContext = _ref.isHabitatContext, isHabitatContext = _ref$isHabitatContext === void 0 ? true : _ref$isHabitatContext, _ref$currentApp = _ref.currentApp, currentApp = _ref$currentApp === void 0 ? "explore" : _ref$currentApp, currentPlatform = _ref.currentPlatform, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$currentRole = _ref.currentRole, currentRole = _ref$currentRole === void 0 ? import_roles.NOT_ROLE_SELECTED : _ref$currentRole, _ref$availableRoles = _ref.availableRoles, availableRoles = _ref$availableRoles === void 0 ? [] : _ref$availableRoles, _ref$popoversStackOrd = _ref.popoversStackOrders, popoversStackOrders = _ref$popoversStackOrd === void 0 ? 1 : _ref$popoversStackOrd, _ref$stackOrder = _ref.stackOrder, stackOrder = _ref$stackOrder === void 0 ? 101 : _ref$stackOrder, _ref$appElement = _ref.appElement, appElement = _ref$appElement === void 0 ? "head" : _ref$appElement, _ref$withKebabMenu = _ref.withKebabMenu, withKebabMenu = _ref$withKebabMenu === void 0 ? true : _ref$withKebabMenu, _ref$tabIndexSkipToCo = _ref.tabIndexSkipToContent, tabIndexSkipToContent = _ref$tabIndexSkipToCo === void 0 ? 0 : _ref$tabIndexSkipToCo, _ref$stickyControl = _ref.stickyControl, stickyControl = _ref$stickyControl === void 0 ? "alwaysSticky" : _ref$stickyControl, _ref$withTitleWrap = _ref.withTitleWrap, withTitleWrap = _ref$withTitleWrap === void 0 ? false : _ref$withTitleWrap, avatarButtonVariant = _ref.avatarButtonVariant, _ref$showAvatarLogout = _ref.showAvatarLogoutButton, showAvatarLogoutButton = _ref$showAvatarLogout === void 0 ? {
    show: true,
    customLabel: void 0,
    customStyles: void 0
    // You may need to expose optional onClick, onFocus, onBlur events here
  } : _ref$showAvatarLogout, _ref$studentVariant = _ref.studentVariant, studentVariant = _ref$studentVariant === void 0 ? false : _ref$studentVariant, _ref$CustomLogoutActi = _ref.CustomLogoutActionElement, CustomLogoutActionElement = _ref$CustomLogoutActi === void 0 ? false : _ref$CustomLogoutActi, _ref$previousArrowLab = _ref.previousArrowLabel, previousArrowLabel = _ref$previousArrowLab === void 0 ? "" : _ref$previousArrowLab, _ref$nextArrowLabel = _ref.nextArrowLabel, nextArrowLabel = _ref$nextArrowLabel === void 0 ? "" : _ref$nextArrowLabel, _ref$titleTextAlignme = _ref.titleTextAlignment, titleTextAlignment = _ref$titleTextAlignme === void 0 ? "left" : _ref$titleTextAlignme, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)(showHamburgerMenuOnLoad), _useState2 = _slicedToArray(_useState, 2), openHamburgerMenu = _useState2[0], setOpenHamburgerMenu = _useState2[1];
  var toggleOpen = function toggleOpen2(event) {
    event.preventDefault();
    setOpenHamburgerMenu(!openHamburgerMenu);
    if (props.toggleMenuOpen)
      props.toggleMenuOpen();
  };
  var hamburgerDrawerRef = (0, import_react.useRef)(null);
  var hamburgerButtonRef = (0, import_react.useRef)(null);
  var headerHeightRef = (0, import_react.useRef)(null);
  var LeftComponent = props.leftSideComponent || null;
  var RightComponent = props.rightSideComponent || null;
  var shouldRemovePageScroll = stickyControl === "disabled200" || stickyControl === "disabled400";
  var _useState3 = (0, import_react.useState)((_headerHeightRef$curr = headerHeightRef.current) === null || _headerHeightRef$curr === void 0 ? void 0 : _headerHeightRef$curr.clientHeight), _useState4 = _slicedToArray(_useState3, 2), headerHeight = _useState4[0], setHeaderHeight = _useState4[1];
  var breakpoints = (0, import_useBreakpoints.useBreakpoints)();
  var is400percent = breakpoints.isSm;
  var focusButton = function focusButton2() {
    hamburgerButtonRef.current.focus();
  };
  (0, import_react.useEffect)(function() {
    var bodyElement = document.body;
    var headerElement = document.querySelector(".styledHeader");
    if (!hideHamburgerMenu) {
      (0, import_Helpers.trapFocus)(hamburgerDrawerRef.current);
    }
    if (openHamburgerMenu && shouldRemovePageScroll) {
      var style = getComputedStyle(headerElement);
      var isSticky = style.position === "sticky";
      if (!isSticky) {
        bodyElement.style.overflow = "hidden";
      }
    } else {
      bodyElement.style.removeProperty("overflow");
    }
  }, [openHamburgerMenu]);
  (0, import_react.useEffect)(function() {
    if (!headerHeightRef.current)
      return void 0;
    var resizeObserver = new ResizeObserver(function() {
      if (headerHeight !== headerHeightRef.current.clientHeight) {
        setHeaderHeight(headerHeightRef.current.clientHeight);
      }
    });
    resizeObserver.observe(headerHeightRef.current);
    return function() {
      return resizeObserver.disconnect();
    };
  }, [headerHeight]);
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader.default, null, props.skipContentHref && /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledSkipToContent, {
    tabIndex: tabIndexSkipToContent,
    zIndex: 102,
    targetId: props.skipContentHref,
    text: "Skip to content",
    dataDpAnalyticsId: "skipToContentDpAnalyticsId"
  }), props.skipToFooterHref && /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledSkipToContent, {
    tabIndex: tabIndexSkipToContent,
    zIndex: 102,
    targetId: props.skipToFooterHref,
    text: "Skip To Footer",
    dataDpAnalyticsId: "skipToFooterDpAnalyticsId"
  }), /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledHeader, _extends({
    className: "styledHeader",
    logoSrc: props.logoSrc,
    toggleOpen,
    ref: (0, import_Helpers.mergeRefs)([headerHeightRef, heightRef]),
    buttonRef: hamburgerButtonRef,
    darkMode,
    popoversStackOrders,
    stackOrder,
    hideHamburgerMenu,
    ariaExpanded: openHamburgerMenu,
    stickyControl,
    withTitleWrap
  }, props), /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledTitleContainer, null, LeftComponent && /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledLeftComponentContainer, null, /* @__PURE__ */ import_react.default.createElement(LeftComponent, null)), BreadcrumbComponent && /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledBreadcrumbComponent, null, /* @__PURE__ */ import_react.default.createElement(BreadcrumbComponent, null), /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledBreadcrumbSeparator, {
    margin: "0 12px"
  })), props.prevButton && /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledPagePrevButton, {
    icon: "chevron-back",
    variant: "empty",
    circle: true,
    iconSize: 26,
    size: "40px",
    "aria-label": previousArrowLabel,
    darkMode,
    onClick: props.prevButton,
    "data-dp-analytics-id": props.prevButtonDataDpAnalyticsId
  }), /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledPageTitle, {
    level: 1,
    titleTextAlignment,
    darkMode,
    withTitleWrap
  }, props.titleCenter), props.nextButton && /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledPageNextButton, {
    icon: "chevron-front",
    variant: "empty",
    circle: true,
    iconSize: 26,
    size: "40px",
    "aria-label": nextArrowLabel,
    darkMode,
    onClick: props.nextButton,
    "data-dp-analytics-id": props.nextButtonDataDpAnalyticsId
  }), RightComponent && /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledRightComponentContainer, null, /* @__PURE__ */ import_react.default.createElement(RightComponent, null))), /* @__PURE__ */ import_react.default.createElement(import_GlobalHeader2.StyledUserToolbar, {
    withKebabMenu: withKebabMenu || studentVariant,
    withTitleWrap
  }, !hideAppSelector && !studentVariant && !(withKebabMenu && is400percent) && /* @__PURE__ */ import_react.default.createElement(import__.GlobalAppSwitcher, {
    "aria-expanded": "false",
    productsList: props.productsList,
    currentPlatform,
    darkMode,
    customPositionOfPopover: {
      left: "-10px"
    },
    withKebabMenu
  }), /* @__PURE__ */ import_react.default.createElement(import_AvatarPopup.AvatarPopup, {
    user: props.user,
    currentPlatform,
    onLogout: props.onLogout,
    onChangeRole: props.onChangeRole,
    darkMode,
    avatarButtonVariant,
    hideHamburgerMenu,
    hideAppSelector,
    currentRole,
    availableRoles,
    appElement,
    withKebabMenu,
    studentVariant,
    showLogoutButton: {
      show: showAvatarLogoutButton.show,
      variant: showAvatarLogoutButton.variant ? showAvatarLogoutButton.variant : "primary",
      customStyles: showAvatarLogoutButton.customStyles,
      customLabel: showAvatarLogoutButton.customLabel,
      customIcon: showAvatarLogoutButton.customIcon ? showAvatarLogoutButton.customIcon : "go-to"
    },
    impersonating: props.impersonating,
    CustomLogoutActionElement,
    endImpersonationButtonText: props.endImpersonationButtonText,
    onEndImpersonation: props.onEndImpersonation,
    impersonator: props.impersonator,
    productsList: props.productsList,
    headerHeight,
    closeAvatarButtonProps: {
      ariaLabel: (_props$closeAvatarBut = props.closeAvatarButtonProps) === null || _props$closeAvatarBut === void 0 ? void 0 : _props$closeAvatarBut.ariaLabel,
      onCloseButtonClick: (_props$closeAvatarBut2 = props.closeAvatarButtonProps) === null || _props$closeAvatarBut2 === void 0 ? void 0 : _props$closeAvatarBut2.onCloseButtonClick
    },
    appSelector: /* @__PURE__ */ import_react.default.createElement(import__.GlobalAppSwitcher, {
      "aria-expanded": "false",
      productsList: props.productsList,
      currentPlatform,
      darkMode,
      customPositionOfPopover: {
        left: "-10px"
      },
      withKebabMenu
    }),
    mobileView: withKebabMenu && is400percent
  }))), !hideHamburgerMenu && /* @__PURE__ */ import_react.default.createElement(import_molecules.GlobalHamburgerMenu, {
    ref: hamburgerDrawerRef,
    open: openHamburgerMenu,
    position: "left",
    size: "206px",
    backgroundColor: import_baseTheme.default.colors.white,
    topOffset: hamburgerMenuTopOffset,
    isHabitatContext,
    currentApp,
    currentRole,
    onClose: function onClose() {
      setOpenHamburgerMenu(false);
    },
    focusButton,
    launchButtonRef: hamburgerButtonRef,
    withTitleWrap
  })));
});
var GlobalHeader_component_default = GlobalHeader;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalHeader
});
//# sourceMappingURL=GlobalHeader.component.js.map